import { render, staticRenderFns } from "./EmailDetail.vue?vue&type=template&id=571431f3&scoped=true"
import script from "./EmailDetail.vue?vue&type=script&lang=js"
export * from "./EmailDetail.vue?vue&type=script&lang=js"
import style0 from "./EmailDetail.vue?vue&type=style&index=0&id=571431f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571431f3",
  null
  
)

export default component.exports